export default [
  // {
  //   path: '/report/instant',
  //   name: 'InstantReport',
  //   component: () => import('@/components/reservation/instant/ReservationReport'),
  //   meta: {
  //     title: 'Instant Report',
  //     requiresAuth: true,
  //     services: ['InstantReport']
  //   }
  // },
  {
    path: '/report/tenant',
    name: 'TenantReport',
    component: () => import('@/components/report/ReportTenant'),
    meta: {
      title: 'Tenant Report',
      requiresAuth: true,
      services: ['TenantReport']
    }
  },
  {
    path: '/report/provider',
    name: 'ProviderReport',
    component: () => import('@/components/report/ReportProvider'),
    meta: {
      title: 'Provider Report',
      requiresAuth: true,
      services: ['ProviderReport']
    }
  },
  {
    path: '/report/customer',
    name: 'CustomerReport',
    component: () => import('@/components/report/ReportCustomer'),
    meta: {
      title: 'Customer Report',
      requiresAuth: true,
      services: ['CustomerReport']
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/reportModule.js